import Icons, { IconsProps } from '../../Icons';

export type VisibilityProps = IconsProps;

// https://www.zhangxinxu.com/sp/svgo/
// https://jakearchibald.github.io/svgomg/

export function Visibility(props: VisibilityProps) {
  return (
    <Icons {...props}>
      <path d="M12 15.65c1.017 0 1.88-.354 2.588-1.063.708-.708 1.062-1.57 1.062-2.587 0-1.017-.354-1.88-1.062-2.588C13.879 8.704 13.017 8.35 12 8.35c-1.017 0-1.879.354-2.587 1.062-.709.709-1.063 1.571-1.063 2.588 0 1.017.354 1.879 1.063 2.587.708.709 1.57 1.063 2.587 1.063Zm0-.95c-.75 0-1.387-.263-1.912-.788A2.601 2.601 0 0 1 9.3 12c0-.75.263-1.388.788-1.913A2.603 2.603 0 0 1 12 9.3c.75 0 1.388.262 1.913.787.525.525.787 1.163.787 1.913s-.262 1.387-.787 1.912A2.605 2.605 0 0 1 12 14.7Zm0 3.8c-2.167 0-4.142-.587-5.925-1.762-1.783-1.175-3.117-2.755-4-4.738.883-1.983 2.217-3.563 4-4.738C7.858 6.087 9.833 5.5 12 5.5s4.142.587 5.925 1.762c1.783 1.175 3.117 2.755 4 4.738-.883 1.983-2.217 3.563-4 4.738C16.142 17.913 14.167 18.5 12 18.5Zm0-1a9.545 9.545 0 0 0 5.188-1.488A9.77 9.77 0 0 0 20.8 12a9.777 9.777 0 0 0-3.612-4.013A9.55 9.55 0 0 0 12 6.5a9.55 9.55 0 0 0-5.188 1.487A9.778 9.778 0 0 0 3.2 12a9.77 9.77 0 0 0 3.612 4.012A9.545 9.545 0 0 0 12 17.5Z" />
    </Icons>
  );
}
